import { restClient } from '@/Core'

import { LETTER_REST_URL } from '../Contracts/ILetter'

/**
 * Видаляє невідправлений лист разом із вкладеннями (`SPEC-013` §7.8, Q13.3):
 * автор або адміністратор, лише за `_permissions.delete`. Підтвердження —
 * справа меню рядка.
 */
export const RemoveLetterTask = async (uuid: string): Promise<void> => {
    await restClient.delete(`${LETTER_REST_URL}/${encodeURIComponent(uuid)}`)
}
